import dayjs from "dayjs";

export const getFormattedDate = (timestamp) => {
  return dayjs(timestamp * 1000).format("DD.MM.YYYY");
};
